import React, { useEffect, useState } from "react";
import illustrationwebmobile from "../../assets/illustrationweb.png";

import { useAuthContext } from "../../hooks/useAuthContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useNavigate } from "react-router-dom";
import OfferModal from "./modals/OfferModal";

export default function HomeOnline({}) {
  const { user } = useAuthContext();
  const [websites, setWebsites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [offer, setOffer] = useState(null);
 const [form,setForm] = useState(null)

  const [showOffer,setShowOffer] = useState(false)

  const navi = useNavigate();

  const fetchData = async () => {
    setIsLoading(true);
    try {

           const formResponse = await axios.get(
        `${ApiConnectionString}/api/counsellingForm`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (formResponse.status == 200) {
       setForm(formResponse.data);
      }

      const websitesResponse = await axios.get(
        `${ApiConnectionString}/api/websites`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (websitesResponse.status == 200) {
        setWebsites(websitesResponse.data);
      }

      const offerResponse = await axios.get(
        `${ApiConnectionString}/api/offer`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (offerResponse.status == 200) {
        setOffer(offerResponse.data);
        setShowOffer(true )
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      fetchData();
    }
  }, [user]);

  useEffect(() => {
  if (form && form.complete === false) {
    navi("/Counselling-concept-form-two");
  }
}, [form]);

  const displayName = user?.name || "there";

  return (
    <div className="container mt-5 pt-4">
      {showOffer &&      <OfferModal offer={offer} onClose={()=> setShowOffer(false)} />}
      <section className="mb-5">
        <div className="row align-items-center g-5">
          {/* Left column */}
          <div className="col-md-6 text-center text-md-start">
            <h1 className="fw-bold display-5 mb-3">
              Welcome to the dashboard
            </h1>
            <p className="text-muted fs-5 mb-4">
              Hi {displayName}. View and manage all of your current websites,
              create new ones, and manage your subscription.
            </p>

            <div className="d-flex justify-content-center justify-content-md-start gap-3 mt-3 flex-wrap">
              <button
                onClick={() => navi(`/createWebsite`)}
                className="btn brand-purple-inline text-white"
              >
                Create new website
              </button>

              <button className="btn brand-purple-outline">
                Manage subscription
              </button>
            </div>
          </div>

          {/* Right column */}
          <div className="col-md-6 text-center">
            <img
              src={illustrationwebmobile}
              alt="Website dashboard illustration"
              className="illustration-img img-fluid"
            />
          </div>
        </div>
      </section>

      {/* OFFER CARD */}
      {offer && (
        <section className="mb-5">
          <h2 className="text-center fw-bold mb-3">
            Your current website offer
          </h2>

          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
              <div className="custom-card-light p-4 rounded-4 shadow-sm text-center">
                <h3 className="fw-bold mb-2">{offer.productName}</h3>
                <p className="text-muted mb-2">{offer.productDescription}</p>

                <p className="fw-semibold fs-5 mb-3">{offer.displayPrice}</p>

                {offer.previewUrl && (
                  <a
                    href={offer.previewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-secondary w-100 mb-2"
                  >
                    Preview website
                  </a>
                )}

                <button className="btn brand-purple-outline w-100">
                  Manage offer
                </button>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* WEBSITES LIST */}
      <section className="pb-5">
        <h2 className="text-center fw-bold mb-3">Your Websites</h2>
        <p className="text-center text-muted mb-4">
          Manage your existing sites or spin up a new one in a few clicks.
        </p>
        {isLoading && <LoadingSpinner />}

        {websites.length === 0 ? (
          <div className="text-center">
            <p className="text-muted mb-3">
              You do not have any websites yet.
            </p>
            <button className="btn brand-purple-inline text-white">
              Create your first website
            </button>
          </div>
        ) : (
          <div className="row justify-content-center">
            {websites.map((site) => (
              <div className="col-md-6 col-lg-4 mb-4" key={site.id}>
                <div className="custom-card-light p-4 rounded-4 shadow-sm h-100 d-flex flex-column">
                  <h3 className="h5 fw-bold mb-1">{site.name}</h3>
                  <p className="text-muted mb-3">
                    {site.description ||
                      "Website hosted with Border City Software."}
                  </p>

                  <p className="small text-muted mb-4">
                    Domain:{" "}
                    <span className="fw-semibold">
                      {site.domain || "No Domain"}
                    </span>
                    <br />
                    Status:{" "}
                    <span className="fw-semibold">
                      {site.status || "Live"}
                    </span>
                  </p>

                  <div className="mt-auto d-flex gap-2 flex-wrap">
                    {site.domain && (
                      <a
                        href={site.domain}
                        className="btn brand-purple-inline text-white flex-grow-1"
                      >
                        Go to site
                      </a>
                    )}
                    <button
                      onClick={() => navi(`/myOneWebsite/${site.id}`)}
                      className="btn brand-purple-outline flex-grow-1"
                    >
                      Settings
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
